import React from "react";

const LocationDetailIcon = (props) => {
  return (
    <>
      <svg
        data-name="Grupo 2555"
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        {...props}
      >
        <defs>
          <clipPath id="a">
            <path
              data-name="Trazado 1226"
              d="M52.686 43.089a1.218 1.218 0 0 0 .974-.507l6.82-9.7.039-.038a9.137 9.137 0 0 0-1.325-11.262 9.165 9.165 0 0 0-14.3 11.262c0 .038.039.038.039.078l6.859 9.7a1.035 1.035 0 0 0 .9.468Zm-4.871-19.874a6.915 6.915 0 0 1 9.7 0 6.782 6.782 0 0 1 1.014 8.339l-5.846 8.34-5.883-8.34a6.841 6.841 0 0 1 1.013-8.339Zm0 0"
              transform="translate(-43.562 -18.919)"
              fill="#202d5b"
            />
          </clipPath>
          <clipPath id="b">
            <path
              data-name="Trazado 1228"
              d="M59.333 31.394a3.975 3.975 0 1 0-3.975 3.975 3.991 3.991 0 0 0 3.975-3.975Zm-3.974 1.636a1.637 1.637 0 1 1 1.636-1.637 1.672 1.672 0 0 1-1.636 1.637Zm0 0"
              transform="translate(-51.384 -27.419)"
              fill="#202d5b"
            />
          </clipPath>
        </defs>
        <g data-name="Grupo 2551">
          <path
            data-name="Trazado 1225"
            d="M9.124 24.17a1.218 1.218 0 0 0 .974-.507l6.82-9.7.039-.038a9.137 9.137 0 0 0-1.325-11.262 9.165 9.165 0 0 0-14.3 11.262c0 .038.039.038.039.078l6.859 9.7a1.035 1.035 0 0 0 .9.468ZM4.253 4.296a6.915 6.915 0 0 1 9.7 0 6.782 6.782 0 0 1 1.014 8.339l-5.846 8.34-5.883-8.34a6.841 6.841 0 0 1 1.013-8.339Zm0 0"
            fill="#202d5b"
          />
          <g data-name="Grupo 2550" clipPath="url(#a)">
            <g data-name="Grupo 2549">
              <path
                data-name="Rect\xE1ngulo 156"
                fill="#202d5b"
                d="M0-.02h18.327v24.212H0z"
              />
            </g>
          </g>
        </g>
        <g data-name="Grupo 2554">
          <path
            data-name="Trazado 1227"
            d="M12.943 9.401a3.975 3.975 0 1 0-3.975 3.975 3.991 3.991 0 0 0 3.975-3.975Zm-3.974 1.636A1.637 1.637 0 1 1 10.605 9.4a1.672 1.672 0 0 1-1.636 1.637Zm0 0"
            fill="#202d5b"
          />
          <g
            data-name="Grupo 2553"
            transform="translate(4.994 5.426)"
            clipPath="url(#b)"
          >
            <g data-name="Grupo 2552">
              <path
                data-name="Rect\xE1ngulo 157"
                fill="#202d5b"
                d="M-.003-.009h7.966v7.966H-.003z"
              />
            </g>
          </g>
        </g>
      </svg>
    </>
  );
};

export default LocationDetailIcon;
